import { LayoutHOC } from "base/ui/layout/layout";
import { createCompletionRate } from "./completionRate";



export const createCompletionRatePage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createCompletionRate());
};